// Polls /api/health every 5 minutes. If the server's APP_VERSION differs
// from the version this React bundle was loaded with, surface a toast
// asking the user to refresh — the next page reload pulls the new build.
//
// Cloud SaaS users see this without lifting a finger when we deploy a
// new release. Desktop installs handle their own updates via
// electron-updater (so we skip the watcher when the Electron flag is
// set).
import { toast } from 'sonner';
import api from './api';

const POLL_INTERVAL_MS = 5 * 60 * 1000;   // 5 min
const INITIAL_DELAY_MS = 30 * 1000;       // wait 30 s after boot

let initialVersion = null;
let timer = null;
let toastShown = false;

async function fetchVersion() {
  try {
    const { data } = await api.get('/health', { timeout: 8000 });
    return (data && data.version) || null;
  } catch {
    return null;
  }
}

function showUpdateToast(newVersion) {
  if (toastShown) return;
  toastShown = true;
  toast(
    `Update available — v${newVersion} is ready`,
    {
      description: 'Refresh the page to load the latest features and fixes.',
      duration: Infinity,
      action: {
        label: 'Refresh now',
        onClick: () => {
          // bypass cache so the new bundle pulls fresh
          window.location.reload();
        },
      },
    },
  );
}

async function tick() {
  const current = await fetchVersion();
  if (!current) return;
  if (!initialVersion) {
    initialVersion = current;
    return;
  }
  if (current !== initialVersion) {
    showUpdateToast(current);
    // Stop polling — the user has been notified once.
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }
}

export function startVersionWatcher() {
  // Skip in Electron — electron-updater handles it natively.
  if (typeof window !== 'undefined' && window.process && window.process.versions && window.process.versions.electron) {
    return;
  }
  // Capture the initial version once.
  setTimeout(() => {
    tick();
    timer = setInterval(tick, POLL_INTERVAL_MS);
  }, INITIAL_DELAY_MS);
}
